import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName, tilerepoShipyardFrameNames } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

export const SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT = 1;
export const BIG_SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT = 3;

type ShipyardFrameNames = FrameName.SHIPYARD | FrameName.BIG_SHIPYARD;

class ShipyardBuildingTileEntity extends TileEntity {
	public static readonly frameName: ShipyardFrameNames = FrameName.SHIPYARD;

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);
		let populationConsumption =
			(consumption.get(ResourceType.POPULATION_CONSUMPTION) as number) ||
			0;
		populationConsumption -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.harbor_crane,
		);
		consumption.set(
			ResourceType.POPULATION_CONSUMPTION,
			populationConsumption,
		);

		return consumption;
	}

	public get seaExplorationPower(): number {
		return (
			SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
			getUpgradeCurrentReplaceValueById(UpgradeIds.seafaring)
		);
	}

	public get maxSeaExplorationPower(): number {
		const shipyardsInSameSea = this.tilerepo.shipyardsInSameSea(this);
		let seaExplorationPower = 0;
		for (const shipyard of shipyardsInSameSea) {
			if (tilerepoShipyardFrameNames.has(shipyard.frameName)) {
				seaExplorationPower += (shipyard as ShipyardBuildingTileEntity)
					.seaExplorationPower;
			}
		}
		return (
			this.tilerepo.basicSeaExploration +
			getUpgradeCurrentReplaceValueById(UpgradeIds.coast_patrol) +
			seaExplorationPower
		);
	}

	public get availableFishingBoats(): number {
		const shipyards = this.tilerepo.getBuildingCountByFrameName(
			FrameName.SHIPYARD,
			true,
		);
		const bigShipyards = this.tilerepo.getBuildingCountByFrameName(
			FrameName.BIG_SHIPYARD,
		);
		const shallowSeaFishingBoats =
			this.tilerepo.getBuildingCountByFrameName(
				FrameName.SHALLOW_SEA_FISHING_BOAT,
				true,
			);
		const deepSeaFishingBoats = this.tilerepo.getBuildingCountByFrameName(
			FrameName.DEEP_SEA_FISHING_BOAT,
		);
		const shallowSeaBigFishingBoats =
			this.tilerepo.getBuildingCountByFrameName(
				FrameName.SHALLOW_SEA_BIG_FISHING_BOAT,
				true,
			);
		const deepSeaBigFishingBoats =
			this.tilerepo.getBuildingCountByFrameName(
				FrameName.DEEP_SEA_BIG_FISHING_BOAT,
			);
		return (
			shipyards *
				(SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
					getUpgradeCurrentReplaceValueById(UpgradeIds.dry_dock)) +
			bigShipyards *
				(BIG_SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
					getUpgradeCurrentReplaceValueById(UpgradeIds.dry_dock)) -
			shallowSeaFishingBoats -
			deepSeaFishingBoats -
			shallowSeaBigFishingBoats -
			deepSeaBigFishingBoats
		);
	}

	public get fishingBoats(): number {
		return (
			SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
			getUpgradeCurrentReplaceValueById(UpgradeIds.dry_dock)
		);
	}
}

export default ShipyardBuildingTileEntity;
